const GREEN_HUE = 142;
const AMBER_HUE = 38;
const RED_HUE = 0;

export function getSuggestedCharCountColor(count: number, suggestedMax: number): string {
  if (!suggestedMax || suggestedMax <= 0) return '#6b7280';

  const ratio = Math.min(Math.max(count / suggestedMax, 0), 1.3);

  let hue: number;
  if (ratio <= 1) {
    const t = Math.min(Math.max((ratio - 0.6) / 0.4, 0), 1);
    hue = GREEN_HUE + (AMBER_HUE - GREEN_HUE) * t;
  } else {
    const t = Math.min((ratio - 1) / 0.3, 1);
    hue = AMBER_HUE + (RED_HUE - AMBER_HUE) * t;
  }

  return `hsl(${hue.toFixed(0)}, 75%, 38%)`;
}

export function isOverSuggestedCharCount(count: number, suggestedMax: number): boolean {
  return count > suggestedMax;
}
